// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { edit_icon, Search_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import moment from "moment";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../components/StaticData";
import { checkPermission } from "../redux/api/PermissionManager";

const DocumentVerificationList = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    city: "",
    owner: "",
    search: paginationData?.[path]?.search ?? "",
  });
  const [optionsList, setOptionsList] = useState({
    owners: [],
    cities: [],
  });
  const [PropertiesList, setPropertiesList] = useState([]);

  useEffect(() => {
    getOwnerList();
    getCities();
  }, []);

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [selectedFilter.city, selectedFilter.owner, selectedFilter.search, page]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    const { city, from, owner, search, to } = selectedFilter;
    const payload = new FormData();
    payload.append("type", 2);
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (owner) {
      payload.append("owner", owner?.value);
    }
    const res = await post(
      URLS.PROPERTIES_LIST + "?page=" + pageNumber,
      payload
    );
    console.log("overall properties", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setPropertiesList(res?.data);
    }
  };

  // get owners list
  const getOwnerList = async (search) => {
    console.log("search", search);
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`
    );
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name, ...item };
      });
      console.log("owner response success", res, modifiedList);
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  //cities with properties list
  const getCities = async () => {
    const res = await get(URLS.PROPERTY_CITIES);
    console.log("properties cities", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };
  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Requested date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY")}</p>;
        },
      },
      {
        Header: " Property",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.code}</p>
            </div>
          );
        },
      },
      {
        Header: "Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap ">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.owner_code}</p>
            </div>
          );
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Mobile Number",
        accessor: "owner_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Type",
        accessor: "category_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Location",
        accessor: "area_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Requested By",
        accessor: "requested_by_type",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
              <button
                onClick={() => {
                  navigate("/propertie-doc-edit", {
                    state: {
                      type: "edit",
                      owner_id: row.original.owner,
                      id: row.original.id,
                      current_position: "verify",
                    },
                  });
                  // AdminView(row.original.id, "edit");
                }}
                className="cust-btn "
              >
                <img src={edit_icon} alt="" className=" edit-btn " />
              </button>
              {/* )} */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-EDIT-DOCUMENT_VERIFICATION")
      ? [...d, action]
      : d;
  }, [page]);

  return (
    <div>
      <Topbar header={"Properties"} subHead={"Document Verification"} />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2>
      <div className="d-flex ac-je mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          isClearable
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={optionsList?.owners}
          isClearable
          onChange={(e) => {
            handleChangeFilter("owner", e);
          }}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
          value={selectedFilter?.owner}
          placeholder={"Owner"}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={PropertiesList}
        show={true}
      />
    </div>
  );
};
export default DocumentVerificationList;
